import { createClient } from 'contentful';
import { getContentfulApiKey, getContentfulSpaceId } from '../constants';

export const contentfulClient = createClient({
  space: getContentfulSpaceId(),
  accessToken: getContentfulApiKey(),
});

export default contentfulClient;
